module.exports = __webpack_public_path__ + "media/audios/kid/lesson_6/audio_tpc6-78556b3a297204774207783f6cb200b1.m4a";